import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"study_map_detail",
    list_id:"study_map_detail_history",
    x_column_list_arr:[
      {"key":"row_view_open_btn","name":"보기","width":"80","is_show":"1"},
      {"key":"row_view_stu_name","name":"학생명","width":"100","is_show":"1"},
      {"key":"a_date","name":"날짜","width":"110","is_show":"1"},
      {"key":"study_title","name":"교재","width":"200","is_show":"1"},
      {"key":"a_section_name","name":"섹션","width":"200","is_show":"1"},
      {"key":"a_unit_name","name":"소단원","width":"200","is_show":"1"},
      {"key":"row_view_file_cnt","name":"첨부파일","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':300,
      'order_id':'a_update_date DESC',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      "s_class_seq":"",
      "s_school_name":"",
      "s_stu_grade":"",
      "s_stu_state":"now",
      "s_is_par_join":"",
      "s_search_text_type":"name",
      "s_search_text":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;